import {
  CREATE_TASKS_NEW_RECORD,
  CREATE_TASKS_NEW_RECORD_SUCCESS,
  CREATE_TASKS_NEW_RECORD_ERROR,

  SET_RECORD_TYPE,
  UPDATE_NEW_RECORD_STATE,
} from "../actions";
import EnumRecordTypes from "../../enums/enumRecordTypes";

const INIT_STATE = {
  isNewRecordPanelShown: false,
  isNewCommentPanelShown: false,
  recordTypeSelected: EnumRecordTypes.Person,
  loading: false,
  error: "",
  record: {},
  taskRecord: {},
  settingid: null
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case CREATE_TASKS_NEW_RECORD:
      return { ...state, loading: true, error: "", record: action.payload.newRecord };
    case CREATE_TASKS_NEW_RECORD_SUCCESS:
      return { ...state, loading: false, error: "", record: action.payload, isNewRecordPanelShown: false };
    case CREATE_TASKS_NEW_RECORD_ERROR:
      return { ...state, loading: false, error: action.payload.message };

    case SET_RECORD_TYPE:
      return { ...state, recordTypeSelected: action.payload.recordTypeSelected };
    case UPDATE_NEW_RECORD_STATE:
      return { ...state, ...action.payload.updatedValues }
    default:
      return { ...state };
  }
};
